import { render, staticRenderFns } from "./StoryPreviewItem.vue?vue&type=template&id=51910874&"
import script from "./StoryPreviewItem.vue?vue&type=script&lang=js&"
export * from "./StoryPreviewItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports